import { render, staticRenderFns } from "./NotFoundView.vue?vue&type=template&id=0d546388"
import script from "./NotFoundView.vue?vue&type=script&setup=true&lang=js"
export * from "./NotFoundView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports